"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SskyList = void 0;

const material_1 = require("@mui/material");

const react_1 = __importDefault(require("react"));

const SskyTooltip_1 = __importDefault(require("../SskyTooltip"));

const StyledItemList = (0, material_1.styled)(material_1.ListItem)({
  [`&.${material_1.listItemClasses.root}`]: {
    height: 54
  }
});
const StyledListItemSecondaryAction = (0, material_1.styled)(material_1.ListItemSecondaryAction)({
  [`&.${material_1.listItemSecondaryActionClasses.root}`]: {
    top: "50%",
    right: "0",
    position: "absolute",
    transform: "translateY(-50%)"
  }
});
const StyledList = (0, material_1.styled)(material_1.List)({
  [`&.${material_1.listClasses.root}`]: {
    width: "100%",
    maxWidth: 360
  }
});

const SskyList = props => {
  var _a;

  const renderListItem = (index, divider, item) => {
    var _a, _b, _c, _d, _e;

    return react_1.default.createElement(StyledItemList, {
      key: index,
      divider: divider,
      onClick: item.onClick,
      // @ts-ignore
      button: Boolean(item.onClick),
      selected: item.selected,
      classes: {
        root: (_a = props.classes) === null || _a === void 0 ? void 0 : _a.listItem,
        container: (_b = props.classes) === null || _b === void 0 ? void 0 : _b.listItemContainer,
        selected: (_c = props.classes) === null || _c === void 0 ? void 0 : _c.selectedListItem
      },
      className: props.listItemClassName,
      "data-testid": item.dataTestId || `testId-${item.text}`
    }, item.avatar && renderListItemAvatar(item.avatar), react_1.default.createElement(SskyTooltip_1.default, {
      title: item.tooltip || "",
      enterDelay: 100
    }, react_1.default.createElement(material_1.ListItemText, {
      primary: item.text,
      classes: {
        primary: (_d = props.classes) === null || _d === void 0 ? void 0 : _d.listItemText,
        root: (_e = props.classes) === null || _e === void 0 ? void 0 : _e.listItemTextRoot
      }
    })), renderListItemSecondaryAction(item.secondary));
  };

  const renderListItemAvatar = avatar => {
    return react_1.default.createElement(material_1.ListItemAvatar, null, react_1.default.createElement(material_1.Avatar, null, avatar));
  };

  const renderListItemSecondaryAction = secondary => {
    var _a;

    return react_1.default.createElement(StyledListItemSecondaryAction, {
      classes: {
        root: (_a = props.classes) === null || _a === void 0 ? void 0 : _a.listItemSecondaryActionRoot
      }
    }, secondary);
  };

  const lastIndex = props.items.length - 1;
  return react_1.default.createElement(StyledList, {
    dense: props.dense,
    className: `sskyList ${props.className}`,
    classes: {
      root: (_a = props.classes) === null || _a === void 0 ? void 0 : _a.listRoot
    },
    "data-testid": props.dataTestId
  }, props.items.map((item, index) => {
    const addDivider = props.addDividers && index < lastIndex; // add dividers if requested, and after every non-last item.

    return renderListItem(index, Boolean(addDivider), item);
  }));
};

exports.SskyList = SskyList;
SskyList.defaultProps = {
  addDividers: true
};
exports.default = react_1.default.memo(SskyList);